// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"61":"52ffe95d","242":"41547aa2","372":"475596cd","628":"59a4fa04","844":"2228d95f"}[chunkId] + ".js";
};